export const metaOg = ({
  title,
  description,
  image,
  url,
  siteName,
  pageType
} : {
  title: string;
  description: string;
  image: string;
  url: string;
  siteName: string;
  pageType: string;
}) => {
  const titleElements = title
    ? [
        {
          name: "twitter:title",
          content: title,
        },
        {
          property: "og:title",
          content: title,
        },
      ]
    : []
  const descriptionElements = description
    ? [
        {
          name: "twitter:description",
          content: description,
        },
        {
          property: "og:description",
          content: description,
        },
      ]
    : []
  const imageElements = [
    {
      name: "twitter:image",
      content: image,
    },
    {
      property: "og:image",
      content: image,
    },
    {
      name: "twitter:card",
      content: image,
    },
  ]
  return [
    ...titleElements,
    ...descriptionElements,
    ...imageElements,
    { name: "twitter:site", content: siteName },
    { name: "twitter:creator", content: siteName },
    {
      property: "og:url",
      content: url,
    },
    { property: "og:type", content: pageType },
    { property: "og:site_name", content: siteName },
    { property: "og:locale", content: "pl_PL" },
  ]
}